@if (organisation(); as _organisation) {
  <ez-main-layout>
    <ez-stepper></ez-stepper>

    <ez-banner>
      <span ngProjectAs="title">Willkommen bei Ihrer {{ _organisation.shortName }}</span>
      <span ngProjectAs="subtitle">Ihre Authentifizierung</span>
    </ez-banner>
    <p>
      Bitte authentifizieren Sie sich mit den letzten vier Ziffern Ihrer IBAN. Dieser Schritt dient der Sicherheit Ihrer
      Daten.
    </p>
    <form class="form-body" [formGroup]="form" (ngSubmit)="onSubmit()">
      <label class="text--bold" for="password"
        >Letzte vier Ziffern Ihrer IBAN<span aria-hidden="true">&nbsp;*</span></label
      >
      <input
        id="password"
        aria-label="Fokussieren Sie dieses rechteckige Eingabefeld, um sich mit den letzten vier Ziffern Ihrer IBAN zu authentifizieren."
        type="password"
        placeholder="Bitte die letzten vier Ziffern Ihrer IBAN eingeben"
        [formControlName]="CONTROL_NAME"
        [autocomplete]="AutocompleteValue.OFF"
        [class.error]="errorMessage()"
        [attr.aria-required]="true"
      />
      @if (errorMessage(); as _message) {
        <span class="error-message">{{ _message }}</span>
      }
      <ez-required-fields-hint></ez-required-fields-hint>
      <ez-button
        altText="Drücken Sie diesen rechteckigen, orangen Button unterhalb des Eingabefeldes zum Senden Ihres persönlichen Zugangscodes."
        maxWidth="100px"
        [disabled]="!(form && form.valid)"
        [loading]="submitAuthenticationTokenRequestIsLoading()"
        label="Senden"
      ></ez-button>
    </form>
  </ez-main-layout>
}
